<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{path:'/dashboard'}">Inicio</router-link>
                            </li>
                            <li class="breadcrumb-item">
                                <router-link :to="{path:'/admin/balones'}">Balones</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Histórico de balones</li>
                        </ol>
                    </nav>
                </div>

                <div class="col-md-2" style="margin-bottom: 20px">
                    <label><strong>Desde</strong></label>
                    <base-input
                        addon-left-icon="ni ni-calendar-grid-58"
                        style="margin-bottom: 0px">
                        <flat-picker slot-scope="{focus, blur}"
                                     @on-open="focus"
                                     @on-close="blur"
                                     :config="configDate"
                                     class="form-control datepicker"
                                     v-model="from">
                        </flat-picker>
                    </base-input>
                </div>

                <div class="col-md-2" style="margin-bottom: 20px">
                    <label><strong>Hasta</strong></label>
                    <base-input
                        addon-left-icon="ni ni-calendar-grid-58"
                        style="margin-bottom: 0px">
                        <flat-picker slot-scope="{focus, blur}"
                                     @on-open="focus"
                                     @on-close="blur"
                                     :config="configDate"
                                     class="form-control datepicker"
                                     v-model="to">
                        </flat-picker>
                    </base-input>
                </div>

                <div class="col-md-3" style="margin-bottom: 20px">
                    <label><strong>Saco</strong></label>
                    <select name="" class="form-control" v-model="idBagBall" @change="loadMovements">
                        <option value="0">Todos los sacos</option>
                        <option v-for="bagBall in bagBalls" :value=bagBall.id> {{ bagBall.name }}</option>
                    </select>
                </div>

                <div class="col-md-3" style="margin-bottom: 20px">
                    <label><strong>Entrenador</strong></label>
                    <select name="" class="form-control" v-model="idCoach" @change="loadMovements">
                        <option value="0">Todos los entrenadores</option>
                        <option v-for="coach in coaches" :value=coach.id> {{ coach.name }}</option>
                    </select>
                </div>

                <div class="col-md-2" style="margin-bottom: 20px">
                    <label style="display: block"><strong>&nbsp;</strong></label>
                    <button class="btn btn-primary" style="width: 100%" @click="loadMovements">
                        <i class="fas fa-search"></i> Consultar
                    </button>
                </div>


                <div class="col-md-12">

                    <div class="card">

                        <div class="table-responsive">
                            <table class="table table-striped text-nowrap" id="table-services">
                                <thead>
                                <tr>
                                    <th>Entrenador</th>
                                    <th>Saco</th>
                                    <th>Movimiento</th>
                                    <th>Balones</th>
                                    <th>Fecha</th>
                                </tr>
                                </thead>

                                <tbody>
                                <tr v-for="movement in movements">
                                    <td class="align-middle">
                                        {{ movement.coach }}
                                    </td>
                                    <td class="align-middle">
                                        {{ movement.bagball }}
                                    </td>
                                    <td class="align-middle">
                                        <span v-if="movement.type == 0">Coge</span>
                                        <span v-else>Deja</span>
                                    </td>
                                    <td class="align-middle" :class="{ 'text-danger': movement.balls<12 }">
                                        {{ movement.balls }}
                                    </td>
                                    <td class="align-middle">
                                        {{ movement.date | parseDateHour }}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>

            </div>
        </div>

    </div>
</template>
<script>
import axios from 'axios';
import swal from 'sweetalert2'
import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'
import flatPicker from "vue-flatpickr-component";
import {Spanish} from 'flatpickr/dist/l10n/es'
import "flatpickr/dist/flatpickr.css";


export default {
    data() {
        return {
            movements:[],
            idBagBall: 0,
            bagBalls: [],
            idCoach: 0,
            coaches: [],
            from: new Date(new Date().getFullYear(), new Date().getMonth()).toISOString(),
            to: "today",
            configDate: {
                allowInput: false,
                altFormat: 'd-m-Y',
                altInput: true,
                dateFormat: 'Y-m-d',
                locale: Spanish
            },
        };
    },
    components: {flatPicker},
    directives: {
        'b-tooltip': BTooltipDirective
    },
    created() {
        this.loadCoaches();
        this.loadBagBalls();
        this.loadMovements();
    },
    methods: {
        loadMovements() {
            let vm = this;
            axios.get(this.$store.getters.apiUrl + 'bagballs/history', {
                params: {
                    from: vm.from,
                    to: vm.to,
                    idBagBall: vm.idBagBall,
                    idCoach: vm.idCoach,
                    jwt: vm.$store.getters.jwt
                }
            }).then(response => {
                if (response.data.response) {
                    vm.movements = response.data.result;
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        loadCoaches() {
            let vm = this;
            axios.get(this.$store.getters.apiUrl + 'coaches', {
                params: {
                    jwt: vm.$store.getters.jwt,
                    season: vm.$store.getters.season
                }
            }).then(response => {
                if (response.data.response) {
                    vm.coaches = response.data.result;
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        loadBagBalls() {
            let vm = this;
            axios.get(this.$store.getters.apiUrl + 'bagballs', {
                params: {
                    jwt: vm.$store.getters.jwt,
                    season: vm.$store.getters.season
                }
            }).then(response => {
                if (response.data.response) {
                    vm.bagBalls = response.data.result;
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
    }

};
</script>
<style scoped>

.container-fluid {
    margin-top: 39px;
}

.card {
    background-color: #f7fafc !important;
    box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.30) !important;
    border: 1px solid rgba(0, 0, 0, .05);
    border-radius: .375rem;
}

#table-services tbody tr:hover {
    background-color: rgba(62, 92, 75, 0.3);
}

#table-services tbody tr:hover #name-player {
    text-decoration: underline;
}


</style>
